<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-head"><span class="strong">Acknowledgments and Thanks</span></h2>
<p class="noindent"><a id="page_vi"></a><a id="page_vii"><span class="dropcap">I</span>owe a great debt of thanks to Janusz Jarzembowski as not only has he proved to be a great friend but has contributed so much to this work. Janusz has waived the copyright of images reproduced here taken from his late father’s archive now known as the Armoured Hussars Archive. In addition Janusz had freely given advice in correspondence regarding the images and my work in general. I am also grateful for Janusz’s input in providing captions for the images as well as the provision of the map used to illustrate the book.</a></p><a id="page_vii">
<p class="indent">I also wish to thank Roman Hałuszczak for allowing me to use his late father’s book as well as providing other material concerning the Italian Campaign, especially the Battle for Monte Cassino.</p>
<p class="indent">Further thanks go to Andrzej Suchcitz and Jadwiga Kowalska at PISM for their help and cooperation in this work. Their knowledge remains unsurpassed.</p>
<p class="noindent1">Thank you to George Anderson for his swift turnaround of the map and at such a good price. And of course my family, who help me in my daily struggles with IT and tend to keep me on track.</p>
<p class="noindent1">Evan McGilvray</p>
<p class="noindent">Pudsey</p>
<p class="noindent">Palm Sunday 2017.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?56d507dd